export const PDFIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/>
      <path d="M14 2v6h6" fill="none" stroke="currentColor"/>
      <path d="M10 12v-1h1v1h-1zm-2 0v-1h1v1H8zm4 0v-1h1v1h-1z" fill="red"/>
    </svg>
  );
  
  export const ImageIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M8.5 13.5l2.5 3 3.5-4.5 4.5 6H5m16 1V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"/>
    </svg>
  );
  
  export const DocumentTextIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/>
      <path d="M14 2v6h6" fill="none" stroke="currentColor"/>
      <path d="M16 13H8m8 4H8m4-8H8" fill="none" stroke="currentColor"/>
    </svg>
  );